<template>
    <Sheet v-loading="loading.actions['form']">
        <h2>{{routeTitle}}</h2>
        <el-button @click="$router.push('/form')"
                   icon="el-icon-plus"
                   size="mini"
                   type="primary">
            新增
        </el-button>
        <el-button @click="refresh"
                   icon="el-icon-refresh"
                   size="mini">
            重新整理
        </el-button>
        <a class="btn_ods" style="margin-left: 10px;"
           :href="base.concat('api/forms/getFormODS/').concat(queryInfo.text1)
                                          .concat(',').concat(queryInfo.id).concat(',2')" target="_blank"
           v-show="totalItems>0">
            <i class="el-icon-document"></i> ODS文件
        </a>
        <a class="btn_ods" style="margin-left: 10px;"
           :href="base.concat('api/forms/getFormPDF/').concat(queryInfo.text1)
                                          .concat(',').concat(queryInfo.id).concat(',2')" target="_blank"
           v-show="totalItems>0">
            <i class="el-icon-document"></i> PDF文件
        </a>
        <table cellpadding="0" cellspacing="0" class="ncut-table-search" style="width: 100%; padding: 0.5em;">
            <tbody>
                <tr>
                    <td style="width:5em;">查詢條件</td>
                    <td class="ncut-base-form-text" style="width:5em;">姓名：</td>
                    <td class="ncut-base-form-ipt" style="padding: 0.25em; width:6em;" tabindex="1">
                        <el-input v-model="queryInfo.text1" placeholder="請輸入姓名"></el-input>
                    </td>
                    <td class="ncut-base-form-text" style="width:8em;">生理性別：</td>
                    <td style="width:5.5em; ">
                        <el-select v-model="queryInfo.id" placeholder="請選擇" tabindex="2">
                            <el-option v-for="item in genders"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                            <el-option key="n00" label="無" :value="0" :disabled="true" />
                        </el-select>
                    </td>
                    <td style="padding: 0 0 0 3em;">
                        <el-button @click="refresh"
                                   icon="el-icon-refresh">
                            重新整理
                        </el-button>
                    </td>
                </tr>
            </tbody>
        </table>
        <el-table :data="pagedData"
                  :stripe="true"
                  empty-text="無表單"
                  height="620px"
                  row-key="id"
                  size="small">
            <el-table-column label="序號"
                             type="index"></el-table-column>
            <el-table-column label="姓名"
                             prop="name"></el-table-column>
            <el-table-column label="Email"
                             prop="email"></el-table-column>
            <el-table-column label="手機"
                             prop="mobile"></el-table-column>
            <el-table-column label="生日"
                             prop="birthdate"></el-table-column>
            <el-table-column label="生理性別">
                <template #default="{row}">
                    {{(genders.find(g => g.value === row.gender) || {label: ''}).label}}
                </template>
            </el-table-column>
            <el-table-column label="教育程度"
                             prop="education">
                <template #default="{row}">
                    {{(educations.find(g => g.value === row.education) || {label: ''}).label}}
                </template>
            </el-table-column>
            <el-table-column label="來源"
                             prop="sources">
                <template #default="{row}">
                    {{
                    row.sources.split(',')
                    .map(r => (sources.find(s => s.value === parseInt(r)) || {label: ''}).label )
                    .join(',')
                    }}
                </template>
            </el-table-column>
            <el-table-column>
                <template #default="{row}">
                    <el-button @click="onDetails(row)"
                               icon="el-icon-more"
                               size="mini"
                               type="info"></el-button>
                    <el-button @click="onUpdate(row)"
                               icon="el-icon-edit"
                               size="mini"
                               type="primary"></el-button>
                    <el-button @click="onRemove(row)"
                               icon="el-icon-delete"
                               size="mini"
                               type="danger"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="currentPage"
                       :page-size="pageSize"
                       :total="forms.length"
                       @current-change="page => pageChange(page, forms)"
                       background
                       layout="total, prev, pager, next"
                       style="margin-top: 10px;"></el-pagination>
        <el-dialog :visible.sync="showDialog"
                   @closed="onDialogClosed">
            <el-form :model="model"
                     :rules="rules"
                     label-width="120px"
                     ref="form"
                     v-loading="loading.actions['form/update']">
                <el-form-item label="姓名"
                              prop="name">
                    <el-input placeholder="請輸入姓名"
                              v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="電子郵件"
                              prop="email">
                    <el-input placeholder="請輸入行動電話"
                              v-model="model.email"></el-input>
                </el-form-item>
                <el-form-item label="行動電話"
                              prop="mobile">
                    <el-input placeholder="請輸入行動電話"
                              v-model="model.mobile"></el-input>
                </el-form-item>
                <el-form-item label="生理性別"
                              prop="gender">
                    <el-select v-model="model.gender">
                        <el-option :label="g.label"
                                   :value="g.value"
                                   v-for="g in genders"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生日"
                              prop="birthdate">
                    <el-date-picker format="yyyy-MM-dd"
                                    placeholder="請選擇生日"
                                    type="date"
                                    v-model="model.birthdate"></el-date-picker>
                </el-form-item>
                <el-form-item label="教育程度"
                              prop="education">
                    <el-radio-group v-model="model.education">
                        <el-radio :label="e.value"
                                  v-for="e in educations">
                            {{e.label}}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="來源"
                              prop="sources">
                    <el-checkbox-group v-model="model.sources">
                        <el-checkbox :label="e.value"
                                     v-for="e in sources">
                            {{e.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="附件">
                    <el-upload :action="action"
                               :before-remove="handleBeforeRemove"
                               :before-upload="beforeUpload"
                               :data="dataOptions"
                               :headers="uploadHeaders"
                               :limit="4"
                               :on-error="onUploadError"
                               :on-exceed="onExceedLimit"
                               :on-success="onUploadSuccess"
                               ref="upload">
                        <el-button>選擇檔案</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                檔案不超過5MB
                            </div>
                        </template>
                    </el-upload>
                </el-form-item>
                <el-divider v-if="model.uploads.filter(u => !u.new).length">已上傳附件(點選刪除會直接刪除檔案)</el-divider>
                <el-tag :key="u.key"
                        closable
                        v-for="u in model.uploads.filter(u => !u.new)"
                        @close="onRemoveFile(u.key)"
                        @click="handleFile(u)"
                        style="margin-right: 5px;">
                    <span class="filename">{{u.name + u.extension}}</span>
                </el-tag>
            </el-form>
            <template #footer>
                <el-button @click="showDialog = false"
                           :loading="loading.actions['form/update']">
                    離開
                </el-button>
                <el-button @click="submit"
                           :loading="loading.actions['form/update']">
                    更新
                </el-button>
            </template>
        </el-dialog>
        <el-dialog :visible.sync="showDetailsDialog"
                   @closed="onshowDetailsDialogClosed">
            <el-form :data="pagedData"
                     :stripe="true"
                     disabled
                     empty-text="無表單"
                     height="620px"
                     row-key="id"
                     size="small">
                     
                <el-form-item label="姓名"
                              prop="name">
                    <el-input placeholder="請輸入姓名"
                              v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="電子郵件"
                              prop="email">
                    <el-input placeholder="請輸入行動電話"
                              v-model="model.email"></el-input>
                </el-form-item>
                <el-form-item label="行動電話"
                              prop="mobile">
                    <el-input placeholder="請輸入行動電話"
                              v-model="model.mobile"></el-input>
                </el-form-item>
                <el-form-item label="生理性別"
                              prop="gender">
                    <el-select v-model="model.gender">
                        <el-option :label="g.label"
                                   :value="g.value"
                                   v-for="g in genders"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生日"
                              prop="birthdate">
                    <el-date-picker format="yyyy-MM-dd"
                                    placeholder="請選擇生日"
                                    type="date"
                                    v-model="model.birthdate"></el-date-picker>
                </el-form-item>
                <el-form-item label="教育程度"
                              prop="education">
                    <el-radio-group v-model="model.education">
                        <el-radio :label="e.value"
                                  v-for="e in educations">
                            {{e.label}}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="來源"
                              prop="sources">
                    <el-checkbox-group v-model="model.sources">
                        <el-checkbox :label="e.value"
                                     v-for="e in sources">
                            {{e.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-divider v-if="model.uploads.filter(u => !u.new).length">已上傳附件(點選刪除會直接刪除檔案)</el-divider>
                <el-tag :key="u.key"
                        :closable="false"
                        v-for="u in model.uploads.filter(u => !u.new)"
                        @close="onRemoveFile(u.key)"
                        @click="handleFile(u)"
                        style="margin-right: 5px;">
                    <span class="filename">{{u.name + u.extension}}</span>
                </el-tag>
            </el-form>
            <template #footer>
                <el-button @click="showDetailsDialog = false">
                    離開
                </el-button>

            </template>
        </el-dialog>
        <el-dialog :visible.sync="showFileDialog"
                   @closed="onFileDialogClosed">
            <el-row>
                <el-col :span="20" style="padding: 0.5rem 0.5rem 0 0.5rem;">
                    <p class="arrow"
                       v-if="pdfDoc!=''">
                        頁數：<span class="turn" style="font-weight: bold;"
                                 :style="{'color': pBtnColor}"
                                 @click="changePdfPage(0)"><i class="el-icon-arrow-left"></i>{{$t('Preview_txt')}}</span>
                        {{currPdfPage}} / {{pageCount}}
                        <span class="turn" style="font-weight: bold;"
                              :style="{'color': nBtnColor}"
                              @click="changePdfPage(1)">{{$t('NextPage_txt')}}<i class="el-icon-arrow-right"></i></span>
                    </p>
                </el-col>
                <el-col :span="4" style="text-align: end; padding: 0.5rem 0.5rem 0 0.5rem;">
                    <el-button round icon="el-icon-close" size="mini"
                               @click="clearPdfFile()">關閉附件</el-button>
                </el-col>
            </el-row>
            <pdf scale="page-width" style="width:100%;margin:0.25em auto;border: 1px solid #BBCDC5 !important;"
                 :src="pdfDoc"
                 :page="currPdfPage"
                 @num-pages="pageCount=$event"
                 @page-loaded="currPdfPage=$event"
                 @loaded="loadPdfHandler"></pdf>
        </el-dialog>
        <el-dialog :visible.sync="showImgDialog"
                   @closed="onImgDialogClosed">
            <el-button round icon="el-icon-close" size="mini"
                       @click="clearImgFile()">關閉附件</el-button>
            <div class="viewer-wrapper" style="overflow:hidden;">
                <viewer :images="images"
                        @inited="inited"
                        class="viewer" ref="viewer">
                    <template slot-scope="scope">
                        <figure class="images">
                            <div class="image-wrapper" v-for="{source, thumbnail} in scope.images" :key="source">
                                <img class="image" style="max-width: 68em; max-height:80em;"
                                     :src="thumbnail" :data-source="source" :alt="source.split('?image=').pop()" />
                            </div>
                        </figure>
                    </template>
                </viewer>
            </div>
        </el-dialog>
    </Sheet>
</template>

<script>
import {mapActions, mapState} from 'vuex';
    import moment from 'moment';
    import routeTitleMixin from './routeTitleMixin';
    import pagingMixin from '../pagingMixin';
    import UploadMixin from '../uploadMixin';
    import {base} from '../constants';
    import pdf from 'vue-pdf';

    const defaultModel = {
        id: null,
        name: '',
        email: '',
        mobile: '',
        gender: null,
        education: null,
        sources: [],
        birthdate: null,
        uploads: [],
    };
    export default {
        name: 'Table',
        mixins: [routeTitleMixin, pagingMixin, UploadMixin],
        data: () => ({
            //pageSize: 1,
            base: base,
            model: {...defaultModel},
            rules: {
                name: [
                    {required: true, message: '請輸入姓名', trigger: 'blur'}
                ],
                email: [
                    {required: true, message: '請輸入姓名', trigger: 'blur'},
                    {type: 'email', message: '請輸入合格的信箱', trigger: ['blur', 'change']}
                ],
                mobile: [
                    {required: true, message: '請輸入電話', trigger: 'blur'}
                ],
                gender: [
                    {required: true, message: '請選擇生理性別'}
                ],
                birthdate: [
                    {required: true, message: '請輸入生日'}
                ],
                education: [
                    {required: true, message: '請選擇教育程度'}
                ]
            },
            showDialog: false,
            showDetailsDialog:false,
            url: 'upload',
            queryInfo: {
                id  : 0,
                text1: ''
            },
            totalItems: 0,
            showFileDialog: false,
            pdfDoc: '',
            numPages: 0,
            currPdfPage: 0, // pdf文件页码
            pageCount: 0, // pdf文件总页数
            showImgDialog: false,
            images: [],
        }),
        components: {
            pdf
        },
        computed: {
            ...mapState('form', ['forms', 'selectedForm']),
            ...mapState(['loading']),
            genders() {
                return [
                    {label: '男', value: 1},
                    {label: '女', value: 2},
                ];
            },
            educations() {
                return [
                    {label: '國小', value: 1,},
                    {label: '國中', value: 2,},
                    {label: '高中', value: 3,},
                    {label: '大學', value: 4,},
                ]
            },
            sources() {
                return [
                    {label: '新聞', value: 1,},
                    {label: '雜誌', value: 2,},
                    {label: '電視', value: 3,},
                ]
            },
            pBtnColor () {
                return (this.currPdfPage==1?'#b2bbbe': '#207f4c');
            },
            nBtnColor () {
                return (this.currPdfPage==this.pageCount?'#b2bbbe': '#c1651a');
            }
        },
        methods: {
            ...mapActions('form',
                {
                    getAll: 'getFormsAction',
                    queryForm: 'getFormsByInfo',
                    get: 'getFormAction',
                    remove: 'removeFormAction',
                    update: 'updateFormAction'
                }
            ),

            ...mapActions({
                'removeFile': 'removeFileAction',
                'download': 'downloadFileAction',
            }),

            onFileDialogClosed(){
                this.showFileDialog = false;
                this.pdfDoc = '';
            },
             onshowDetailsDialogClosed(){
                this.showDetailsDialog = false;
            },
            clearPdfFile(){
                this.onFileDialogClosed();
            },
            changePdfPage (val) {
                if (val === 0 && this.currPdfPage > 1) {
                    this.currPdfPage--;
                }
                if (val === 1 && this.currPdfPage < this.pageCount) {
                    this.currPdfPage++
                }
            },
            loadPdfHandler (e) {
             this.currPdfPage = 1;
            },
            setUrl(data) {
                var tUrl = this.base.concat('api/upload?key=').concat(data.key);
                if (['.jpg'].includes(data.extension)) {
                    this.images = [];
                    this.images.push({
                        thumbnail: tUrl,
                        source: tUrl
                    })
                    this.curRowId = null;
                    this.showImgDialog = true;
                } else {
                        this.pdfDoc = pdf.createLoadingTask(tUrl);
                        this.pdfDoc.then(pdf => {
                                                    this.numPages = pdf.numPages;
                                                });
                        this.showFileDialog = true;
                }
            },

            onImgDialogClosed(){
                this.showImgDialog = false;
                this.pdfDoc = '';
            },
            clearImgFile(){
                this.onImgDialogClosed();
            },
            inited (viewer) {
            this.$viewer = viewer
            },

            async onUpdate({id}) {
                const current = await this.get(id);
                if (current) {
                    this.showDialog = true;
                    this.model = {...current, sources: current.sources ? current.sources.split(',').map(s => parseInt(s)) : []};
                } else {
                    this.$message.warning('查無此資料');
                }
            },

           async onDetails({id}) {
                const current = await this.get(id);
                if (current) {
                    this.showDetailsDialog = true;
                    this.model = {...current, sources: current.sources ? current.sources.split(',').map(s => parseInt(s)) : []};
                } else {
                    this.$message.warning('查無此資料');
                }
            },

            async onRemove({id}) {
                try {
                    await this.$confirm('確定要刪除嗎?(刪除後將不能回復)', {
                        type: 'danger',
                    });
                    const {success} = await this.remove(id);
                    if (success) {
                        this.$message.success('刪除成功');
                    } else {
                        this.$message.warning('刪除失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },

            async refresh() {
              //await this.getAll();
                await this.queryForm(this.queryInfo);
            },

            onUploadSuccess(res) {
                this.model.uploads.push({...res, new: true});
            },

            async handleBeforeRemove(file) {
                await this.beforeRemove(file);
                this.model.uploads = this.model.uploads.filter(f => f.uid !== file.uid);
            },

            async onRemoveFile(key){
                await this.removeFile({key});
                this.model.uploads = this.model.uploads.filter(u => u.key !== key);
            },

            async handleFile(u) {
                if (['.jpg','.pdf'].includes(u.extension)) {
                    this.setUrl(u);
                } else {
                    this.onDownloadFile({key: u.key, fullName:u.name + u.extension });
                }
            },

            async onDownloadFile({key, fullName}){
                await this.download({key, fullName});
            },

            onDialogClosed(){
                this.reset();
            },

            submit() {
                const current = this.$refs['form'];
                current.validate(async valid => {
                    if (valid) {
                        const sources = (this.model.sources || '').join(',');
                        const {success} = await this.update({
                            ...this.model,
                            sources,
                            uploads : this.model.uploads.filter(u => u.new),
                            birthdate: moment(this.model.birthdate).format('YYYY-MM-DD')
                        });

                        if (success) {
                            this.$message({
                                type: 'success',
                                message: '表單送出成功'
                            });
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '表單送出失敗，請重試一次'
                            });
                        }
                        this.reset();
                        this.showDialog = false;
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                })
            },

            reset() {
                const vm = this;
                this.$refs['form'].resetFields();
                this.$nextTick(() => vm.$refs['form'].clearValidate());
                this.model = {...defaultModel};
                this.$refs['upload'].clearFiles();
            },

            async query() {
                await this.queryForm(this.queryInfo);
/*                 if (success) {
                    this.totalItems = this.newsList.length;
                } */
            }
        },

        watch: {
            forms(current) {
                this.pagedData = this.pageData(current, 1);
                this.currentPage = 1;
                this.totalItems = (null != this.pagedData? this.pagedData.length: 0);
            }
        },

        async created() {
            await this.getAll();
        }
    }</script>

<style scoped>
    @import '../assets/styles/ncut.css';
    .filename{
        cursor: pointer;
    }
</style>